import React, {useEffect} from 'react';
import Backdrop from '@mui/material/Backdrop';
import makeStyles from '@mui/styles/makeStyles';
import './BidmiiCustomLoader.css';
import {useRecoilState, useRecoilValue} from 'recoil';
import {loadingState} from '../../recoil/bidmiiCustomLoader/bidmiiCustomLoaderAtom';
import {tb} from '../../recoil/user/userAtom';

/**
 * BidmiiCustomLoader displays a full-screen loading overlay with animated dots.
 * The loader can be controlled via props or global loading state from Recoil.
 * It shows a backdrop with five animated colored dots that bounce in sequence.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.loading - Optional prop to control loader visibility
 * @returns {JSX.Element} A backdrop component with animated loading dots
 */
export default function BidmiiCustomLoader(props: $TSFixMe) {
  const [loading, setLoading] = useRecoilState(loadingState);
  const tbvalue = useRecoilValue(tb);

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: 100000,
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(230, 230, 230, 0.7)',
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    if (tbvalue) {
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={props.loading || loading}>
        <div
          style={{
            display: 'flex',
            marginRight: window.innerWidth > 600 ? 4 : 0,
          }}>
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
        </div>
      </Backdrop>
    </div>
  );
}
